import {
  Layout,
  Typography,
  Card,
  Space,
  Divider,
  Row,
  Col,
  Tag,
  Alert,
  Image,
} from 'antd';
import {
  SecurityScanOutlined,
  MailOutlined,
  HomeOutlined,
  LockOutlined,
  UserOutlined,
  SafetyOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

export const PrivacyPolicy = () => {

  return (
    <Layout style={{ minHeight: '100vh',
      backgroundColor: '#f5f5f5' }}>
      <Content style={{ padding: '24px',
        margin: '0 auto',
        overflow: 'auto' }}>
        {/* Header Section */}
        <Card
          style={{
            marginBottom: '24px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          }}
        >
          <Row justify="space-between" align="middle">
            <Col>
              <Space size="large">
                <Space>
                  <SecurityScanOutlined style={{ fontSize: '24px',
                    color: '#c32dee' }} />
                  <Title level={2} style={{ margin: 0,
                    color: '#262626' }}>
                    Aviso de Privacidad
                  </Title>
                </Space>
              </Space>
            </Col>
          </Row>
        </Card>

        {/* Main Content */}
        <Card
          style={{
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          }}
        >
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            {/* Brand Header */}
            <div style={{ textAlign: 'center',
              marginBottom: '32px' }}>
              <Image src="/logo-pollo-loco.png" style={{ width: '15%' }} /> <br />
              <Text type="secondary" style={{ fontSize: '16px' }}>
                Aviso de Privacidad y Protección de Datos Personales
              </Text>
              <div style={{ marginTop: '16px' }}>
                <Tag color="green" style={{ fontSize: '12px' }}>
                  <SafetyOutlined /> Datos Protegidos
                </Tag>
              </div>
            </div>

            {/* Privacy Alert */}
            <Alert
              message="Compromiso con su Privacidad"
              description="En Pollo Loco nos comprometemos a proteger y respetar su privacidad. Este aviso explica cómo recopilamos, usamos y protegemos su información personal."
              type="info"
              icon={<InfoCircleOutlined />}
              showIcon
            />

            <Divider />

            {/* Responsible Party */}
            <div>
              <Title level={3} style={{ color: '#c32dee',
                marginBottom: '2px' }}>
                <UserOutlined style={{ marginRight: '8px' }} />
                Responsable del Tratamiento de Datos Personales
              </Title>
              <Card
                style={{
                  backgroundColor: '#f9f9f9',
                  border: '1px solid #e8e8e8',
                  borderRadius: '8px',
                }}
              >
                <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                  <div>
                    <Text strong>Nombre Comercial:</Text>
                    <br />
                    <Text style={{ fontSize: '16px',
                      color: '#c32dee' }}>EL POLLO LOCO</Text>
                  </div>

                  <Space size="middle" align="start">
                    <HomeOutlined style={{ color: '#c32dee',
                      fontSize: '18px',
                      marginTop: '4px' }} />
                    <div>
                      <Text strong>Domicilio:</Text>
                      <br />
                      <Text style={{ lineHeight: '1.6' }}>
                        Boulevard Miguel Ramos Arizpe Sur #18<br />
                        Col. Ramos Arizpe Centro<br />
                        C.P. 25900, Ramos Arizpe<br />
                        Coahuila de Zaragoza, México
                      </Text>
                    </div>
                  </Space>

                  <Space size="middle">
                    <MailOutlined style={{ color: '#c32dee',
                      fontSize: '18px' }} />
                    <div>
                      <Text strong>Correo electrónico de contacto:</Text>
                      <br />
                      <Text copyable style={{ color: '#c32dee' }}>
                        polloloco@abdotech.mx
                      </Text>
                    </div>
                  </Space>
                </Space>
              </Card>
            </div>

            <Divider />

            {/* Section 1: Data Collection */}
            <div>
              <Title level={3} style={{ color: '#c32dee',
                marginBottom: '16px' }}>
                1. Datos Personales que Recopilamos
              </Title>
              <Paragraph style={{ fontSize: '16px',
                lineHeight: '1.6',
                textAlign: 'justify',
                marginBottom: '16px' }}>
                Podemos recabar de manera directa o indirecta, a través de nuestra aplicación móvil <Text strong>&quot;Pollo Loco&quot;</Text>,
                los siguientes datos personales:
              </Paragraph>

              <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                <Card size="small" style={{ backgroundColor: '#fafafa' }}>
                  <Text strong>• Datos de identificación:</Text> nombre completo, número de teléfono, dirección de correo electrónico.
                </Card>
                <Card size="small" style={{ backgroundColor: '#fafafa' }}>
                  <Text strong>• Datos de ubicación:</Text> ubicación aproximada o GPS.
                </Card>
                <Card size="small" style={{ backgroundColor: '#fafafa' }}>
                  <Text strong>• Datos de interacción con la app:</Text> historial de pedidos, preferencias de consumo.
                </Card>
                <Card size="small" style={{ backgroundColor: '#fafafa' }}>
                  <Text strong>• Datos de pago:</Text> información para procesar pagos, facturación o reembolsos.
                </Card>
              </Space>

              <Paragraph style={{ fontSize: '16px',
                lineHeight: '1.6',
                textAlign: 'justify',
                marginTop: '16px' }}>
                En caso de utilizar funciones adicionales como cámara, micrófono o acceso a contactos,
                se solicitará su autorización previa.
              </Paragraph>
            </div>

            <Divider />

            {/* Section 2: Purpose */}
            <div>
              <Title level={3} style={{ color: '#c32dee',
                marginBottom: '16px' }}>
                2. Finalidades del Tratamiento
              </Title>
              <Paragraph style={{ fontSize: '16px',
                lineHeight: '1.6',
                textAlign: 'justify',
                marginBottom: '16px' }}>
                Los datos personales recabados serán utilizados para las siguientes finalidades:
              </Paragraph>
              <Space direction="vertical" size="small" style={{ width: '100%' }}>
                <Paragraph style={{ fontSize: '16px',
                  lineHeight: '1.6',
                  marginBottom: '8px' }}>
                  • Procesar y entregar pedidos realizados en la app.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px',
                  lineHeight: '1.6',
                  marginBottom: '8px' }}>
                  • Crear y administrar cuentas de usuario.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px',
                  lineHeight: '1.6',
                  marginBottom: '8px' }}>
                  • Enviar notificaciones relacionadas con pedidos, promociones y novedades.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px',
                  lineHeight: '1.6',
                  marginBottom: '8px' }}>
                  • Mejorar la experiencia de usuario y optimizar el funcionamiento de la app.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px',
                  lineHeight: '1.6' }}>
                  • Cumplir con obligaciones legales aplicables.
                </Paragraph>
              </Space>
            </div>

            <Divider />

            {/* Section 3: Data Transfer */}
            <div>
              <Title level={3} style={{ color: '#c32dee',
                marginBottom: '16px' }}>
                3. Transferencia de Datos Personales
              </Title>
              <Paragraph style={{ fontSize: '16px',
                lineHeight: '1.6',
                textAlign: 'justify',
                marginBottom: '16px' }}>
                Podremos compartir sus datos con:
              </Paragraph>
              <Space direction="vertical" size="small" style={{ width: '100%' }}>
                <Paragraph style={{ fontSize: '16px',
                  lineHeight: '1.6',
                  marginBottom: '8px' }}>
                  • Proveedores de servicios de pago para procesar transacciones.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px',
                  lineHeight: '1.6',
                  marginBottom: '8px' }}>
                  • Plataformas de entrega o servicios de mensajería para la gestión de pedidos.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px',
                  lineHeight: '1.6',
                  marginBottom: '16px' }}>
                  • Proveedores de tecnología para alojamiento, soporte y mantenimiento de la app.
                </Paragraph>
              </Space>
              <Paragraph style={{ fontSize: '16px',
                lineHeight: '1.6',
                textAlign: 'justify' }}>
                En todos los casos, se exigirá a terceros el cumplimiento de las disposiciones legales
                de protección de datos personales.
              </Paragraph>
            </div>

            <Divider />

            {/* Section 4: Security Measures */}
            <div>
              <Title level={3} style={{ color: '#c32dee',
                marginBottom: '16px' }}>
                <LockOutlined style={{ marginRight: '8px' }} />
                4. Medidas de Seguridad
              </Title>
              <Paragraph style={{ fontSize: '16px',
                lineHeight: '1.6',
                textAlign: 'justify' }}>
                Adoptamos medidas administrativas, técnicas y físicas para proteger sus datos personales
                contra daño, pérdida, alteración, destrucción o uso no autorizado, incluyendo
                cifrado SSL, firewalls y protocolos de seguridad avanzados.
              </Paragraph>
            </div>

            <Divider />

            {/* Section 5: Data Retention */}
            <div>
              <Title level={3} style={{ color: '#c32dee',
                marginBottom: '16px' }}>
                5. Conservación de Datos
              </Title>
              <Paragraph style={{ fontSize: '16px',
                lineHeight: '1.6',
                textAlign: 'justify' }}>
                Los datos personales serán conservados únicamente por el tiempo necesario para cumplir
                con las finalidades mencionadas o conforme a lo que establezca la legislación aplicable.
              </Paragraph>
            </div>

            <Divider />

            {/* Section 6: ARCO Rights */}
            <div>
              <Title level={3} style={{ color: '#c32dee',
                marginBottom: '16px' }}>
                6. Derechos ARCO (Acceso, Rectificación, Cancelación y Oposición)
              </Title>
              <Paragraph style={{ fontSize: '16px',
                lineHeight: '1.6',
                textAlign: 'justify',
                marginBottom: '16px' }}>
                Usted tiene derecho a:
              </Paragraph>

              <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                <Card size="small" style={{ backgroundColor: '#f0f9ff',
                  border: '1px solid #bae6fd' }}>
                  <Text strong>• Acceder</Text> a sus datos personales.
                </Card>
                <Card size="small" style={{ backgroundColor: '#f0f9ff',
                  border: '1px solid #bae6fd' }}>
                  <Text strong>• Solicitar su rectificación</Text> si son inexactos o incompletos.
                </Card>
                <Card size="small" style={{ backgroundColor: '#f0f9ff',
                  border: '1px solid #bae6fd' }}>
                  <Text strong>• Solicitar su cancelación</Text> cuando considere que no se requieren para alguna de las finalidades señaladas.
                </Card>
                <Card size="small" style={{ backgroundColor: '#f0f9ff',
                  border: '1px solid #bae6fd' }}>
                  <Text strong>• Oponerse al uso</Text> de los mismos para fines específicos.
                </Card>
              </Space>

              <Paragraph style={{ fontSize: '16px',
                lineHeight: '1.6',
                textAlign: 'justify',
                marginTop: '16px' }}>
                Para ejercer estos derechos, envíe una solicitud al correo <Text strong copyable style={{ color: '#c32dee' }}>polloloco@abdotech.mx</Text>
                indicando su nombre completo, descripción clara de la solicitud y, de ser necesario,
                documentos que acrediten su identidad.
              </Paragraph>
            </div>

            <Divider />

            {/* Section 7: Minors */}
            <div>
              <Title level={3} style={{ color: '#c32dee',
                marginBottom: '16px' }}>
                7. Uso de Datos de Menores
              </Title>
              <Paragraph style={{ fontSize: '16px',
                lineHeight: '1.6',
                textAlign: 'justify' }}>
                No recabamos de manera intencional datos de menores de edad sin el consentimiento expreso
                de padres o tutores. Si detectamos que un menor ha proporcionado datos sin dicho consentimiento,
                procederemos a eliminarlos de inmediato.
              </Paragraph>
            </div>

            <Divider />

            {/* Section 8: Cookies */}
            <div>
              <Title level={3} style={{ color: '#c32dee',
                marginBottom: '16px' }}>
                8. Uso de Cookies y Tecnologías Similares
              </Title>
              <Paragraph style={{ fontSize: '16px',
                lineHeight: '1.6',
                textAlign: 'justify' }}>
                Nuestra app podrá utilizar cookies y tecnologías similares para mejorar la experiencia del usuario
                y obtener estadísticas de uso. Usted puede desactivar las cookies desde la configuración de su dispositivo,
                aunque esto podría afectar ciertas funcionalidades.
              </Paragraph>
            </div>

            <Divider />

            {/* Section 9: Modifications */}
            <div>
              <Title level={3} style={{ color: '#c32dee',
                marginBottom: '16px' }}>
                9. Modificaciones al Aviso de Privacidad
              </Title>
              <Paragraph style={{ fontSize: '16px',
                lineHeight: '1.6',
                textAlign: 'justify' }}>
                Nos reservamos el derecho de efectuar en cualquier momento modificaciones o actualizaciones
                al presente Aviso de Privacidad. Dichas modificaciones estarán disponibles dentro de la aplicación.
              </Paragraph>
            </div>

            {/* Footer */}
            <div style={{ textAlign: 'center',
              marginTop: '48px',
              paddingTop: '24px',
              borderTop: '1px solid #f0f0f0' }}>
              <Text type="secondary" style={{ fontSize: '14px' }}>
                © 2025 Pollo Loco. Todos los derechos reservados.
              </Text>
              <br />
              <Text type="secondary" style={{ fontSize: '12px' }}>
                Fecha de última actualización: Agosto 2025
              </Text>
            </div>
          </Space>
        </Card>
      </Content>
    </Layout>
  );
};
